import { Platform, Alert } from 'react-native';
import type { WindowComponentType } from '../Components/UnifiedWindow';

/**
 * Calculate window width: max 50% of screen, min 800px
 */
export const calculateWindowWidth = (screenWidth: number): number => {
  const maxWidth = screenWidth * 0.5;
  const minWidth = 800;
  return Math.max(minWidth, Math.min(maxWidth, screenWidth * 0.5));
};

/**
 * Handle unified window toggle - all components use the same window
 */
export const createHandleToggleWindow = (
  setActiveWindowComponent: React.Dispatch<React.SetStateAction<WindowComponentType>>
) => {
  return (componentType: WindowComponentType) => {
    setActiveWindowComponent((prev) => {
      if (prev === componentType) {
        return null;
      }
      return componentType;
    });
  };
};

/**
 * Convenience handlers for each component type
 */
export const createWindowToggleHandlers = (
  handleToggleWindow: (componentType: WindowComponentType) => void
) => {
  const handleToggleHierarchy = () => {
    if (Platform.OS === 'ios' || Platform.OS === 'android') {
      Alert.alert('Coming Soon', 'This feature is coming soon!', [{ text: 'OK' }]);
      return;
    }
    handleToggleWindow('hierarchy');
  };

  const handleToggleCanvas = () => {
    if (Platform.OS === 'ios' || Platform.OS === 'android') {
      Alert.alert('Coming Soon', 'This feature is coming soon!', [{ text: 'OK' }]);
      return;
    }
    handleToggleWindow('canvas');
  };

  const handleToggleEditor = () => {
    if (Platform.OS === 'ios' || Platform.OS === 'android') {
      Alert.alert('Coming Soon', 'This feature is coming soon!', [{ text: 'OK' }]);
      return;
    }
    handleToggleWindow('editor');
  };

  const handleToggleDataHandler = () => {
    if (Platform.OS === 'ios' || Platform.OS === 'android') {
      Alert.alert('Coming Soon', 'This feature is coming soon!', [{ text: 'OK' }]);
      return;
    }
    handleToggleWindow('dataHandler');
  };

  return {
    handleToggleHierarchy,
    handleToggleCanvas,
    handleToggleEditor,
    handleToggleDataHandler,
  };
};




